import React from "react";
import { Images } from "./assets";
import { useFormContext } from "react-hook-form";
import { CreateBillDto } from "./model/bill/dto/CreateBillDto";
import { UpdateBillDto } from "./model/bill/dto/UpdateBillDto";
import { useAppSelector } from "./redux/store";
import { billSliceSelectors } from "./redux/bill/bill.selector";
import { Bill } from "./model/bill/types/Bill";

type CreationModalHeaderProps = {
  bill?: Bill | null;
};

export const CreationModalHeader: React.FC<CreationModalHeaderProps> = ({
  bill,
}) => {
  const { register } = useFormContext<CreateBillDto | UpdateBillDto>();
  const billNumber = useAppSelector(billSliceSelectors.selectCurrentBillNumber);

  return (
    <div className="d-flex flex-column w-100 gap-4">
      <div className="d-flex">
        <div className="d-flex flex-column flex-grow-1 gap-2">
          <div className="d-flex align-items-end gap-1">
            <img
              style={{ width: "10%" }}
              src={Images.IconLogo}
              alt="company-logo"
            />
            <p>
              <span style={{ color: "green" }}>SHAM </span>
              <span style={{ color: "purple" }}>IMPORT EXPORT </span>
              <span style={{ color: "blue" }}>LTD</span>
            </p>
          </div>
          <div className="d-flex flex-column gap-1">
            <p>8423 165 ST SURREY, BC, V4N 3H3, Canada</p>
            <p style={{ color: "gray" }}>ahmad.aryan83@gmail.com</p>
            <p>TEL: +1 (236)-888-2596</p>
            <a href="https://www.shamautoparts.com">www.shamautoparts.com</a>
          </div>
        </div>

        <div className="d-flex justify-content-end flex-column flex-grow-1 gap-1">
          <p className="text-danger">INVOICE</p>
          <p>INVOICE NO: {bill?._id ? bill.billNumber : billNumber}</p>
          <p>INVOICE DATE: </p>
          <p className="text-danger">M.D.Y</p>
          <input
            type="date"
            style={{ width: "fit-content" }}
            {...register("invoiceDate")}
          />
          <p>GST NO: 799477930 RT0001</p>
        </div>
      </div>

      <div>
        <p className="fw-bold mb-1">SOLD TO:</p>

        <textarea
          className="w-100"
          placeholder="Sold to information..."
          {...register("soldTo")}
        />
      </div>
    </div>
  );
};
